<template>
  <div class="wrap">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="item in deptList"
        :key="item.id"
        :label="item.label"
        :name="item.id"
      >
      </el-tab-pane>
    </el-tabs>
    <el-tree
      ref="tree"
      :data="treeData"
      show-checkbox
      node-key="id"
      @check="selectClick"
      default-expand-all
      :default-checked-keys="defaultSelect"
    >
    </el-tree>
  </div>
</template>

<script>
export default {
  name: "GroupTree",
  props: {
    deptList: {
      type: Array,
      default: () => [],
      required: true,
    },
    tabName: {
      type: String,
      required: true,
    },
    selectedTree: {
      type: Array,
      default: () => [],
      required: false,
    },
  },
  data() {
    return {
      treeData: [],
      activeName: "",
      defaultSelect: [],
    }
  },
  created() {
    let _this = this
    setTimeout(() => {
      this.activeName = this.tabName
      this.defaultSelect = this.selectedTree
      _this.getDeptTree(_this.activeName)
    }, 200)
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
      this.defaultSelect = []
      this.getDeptTree(this.activeName)
    },
    async getDeptTree(parentId) {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/sys/dept/list?parentId=" + parentId
      )
      if (res.code == 1) {
        _this.treeData = res.data
      }
    },
    selectClick() {
      let selectId = this.$refs.tree.getCheckedKeys(true)
      this.$emit("treeClick", selectId)
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap /deep/ .el-tree {
  height: 340px;
  overflow: auto;
}
</style>
